import './SkeletonTabela.scss';

const { Box, Skeleton } = require('@mui/material');
const { GridOverlay } = require('@mui/x-data-grid');

export default function SkeletonLoadingOverlay() {
  return (
    <GridOverlay className="overlay-tabela-data-grid">
      <Box className="skeleton-loading-data-grid">
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton
            // uma linha “fake” da tabela
            key={index}
            variant="rectangular"
            className="skeleton-shape-data-grid"
          />
        ))}
      </Box>
    </GridOverlay>
  );
}
